import { navigateToUrl } from 'single-spa';
import { keycloakAuth } from './KeycloakAuth';
import handleBreadcrumbs from 'src/utils/breadcrumb-handler';
import SelfOnboardingDataEvent, {
  redirectAndRemoveLink,
  validateAndSetForceRedirect,
} from 'src/utils/helper';
import { fetchUserData } from './sessionLifecycle';
import handleAIChatView from '../utils/ai-chat-handler';
import handleRootAppContainer from '../utils/root-app-container-handler';

export const keycloakSessionLifecycle = async () => {
  if (
    !process.env.KEYCLOAK_URL ||
    !process.env.KEYCLOAK_REALM ||
    !process.env.KEYCLOAK_CLIENT_ID
  ) {
    console.error('Keycloak configuration is missing');
    return;
  }

  await validateAndSetForceRedirect();
  const authenticated = await keycloakAuth.init();

  if (!authenticated && !sessionStorage.getItem('accessToken')) {
    navigateToUrl('/auth/v2/login');
    return;
  } else {
    window.dispatchEvent(
      new CustomEvent('sessionLoading', {
        detail: true,
      })
    );
  }
  SelfOnboardingDataEvent();

  const redirectDisabledRoute = ['/auth/login', '/onboarding/signup'];
  if (window.location.pathname === '/auth/v2/login') {
    await fetchUserData();
  } else if (
    localStorage.getItem('isLoggedInWithIdV2') &&
    !redirectDisabledRoute.some(value =>
      window.location.pathname.includes(value)
    )
  ) {
    if (!sessionStorage.getItem('userId')) {
      navigateToUrl('/auth/v2/login');
      return;
    }
  }

  handleAIChatView();

  handleRootAppContainer();

  if (sessionStorage.getItem('accessToken')) {
    redirectAndRemoveLink();
  } else {
    return;
  }
};
